<header class="site-header">
  <div class="header-container site-header__inner">
  <div class="header-bar" [class.header-bar--open]="menuOpen()">
    <a class="brand" href="/landing" (click)="$event.preventDefault(); goHome()" aria-label="Kore ADU home">
       <img src="assets/images/kore-logo.png" alt="Kore logo" class="brand__logo" />
    </a>

    <button type="button" class="menu-toggle" [attr.aria-expanded]="menuOpen()" aria-controls="primary-nav"
      aria-label="Toggle navigation menu" (click)="toggleMenu()">
      <i class="pi" [class.pi-bars]="!menuOpen()" [class.pi-times]="menuOpen()"></i>
    </button>

    <nav id="primary-nav" class="nav" [class.nav--open]="menuOpen()">
      <ul class="nav__list">
        @for (item of navItems; track item.href) {
        <li class="nav__item">
          <a class="nav__link" [href]="item.href" (click)="closeMenu()">{{ item.label }}</a>
        </li>
        }
      </ul>
      <a class="header-cta" (click)="goToPropertyIntake()">See If My Property Qualifies</a>
      <!-- <button class="header-cta">
        See If My Property Qualifies
      </button> -->
    </nav>
  </div></div>
</header>